import {
  BasicButton,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Modal,
  PrimaryButton,
} from "@certn/cascadia-react";
import { Trans, useTranslation } from "react-i18next";

type DeactivateApplyLinkModalProps = {
  isOpen: boolean;
  isLoading: boolean;
  name: string;
  onCancel: () => void;
  onConfirm: () => void;
};

export function ActivateApplyLinkModal(props: DeactivateApplyLinkModalProps) {
  const { t } = useTranslation();
  const { isOpen, onCancel, onConfirm, name, isLoading } = props;

  return (
    <Modal isOpen={isOpen} testID="activate-apply-link-modal">
      <Dialog>
        <DialogHeader onClose={onCancel}>
          {t("Reactivate ") + name}
        </DialogHeader>
        <DialogContent>
          {t("By clicking 'Reactivate', this apply link will be reactivated. ")}
        </DialogContent>
        <DialogFooter>
          <BasicButton size="medium" onPress={onCancel} testID="cancel-button">
            <Trans>Cancel</Trans>
          </BasicButton>
          <PrimaryButton
            type="submit"
            size="medium"
            isLoading={isLoading}
            onPress={() => onConfirm()}
            testID="reactivate-confirm-button"
          >
            <Trans>Reactivate</Trans>
          </PrimaryButton>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
